import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function SocialIcon({ type }) {
  if (type === 'github') {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 .5C5.73.5.5 5.85.5 12.3c0 5.12 3.29 9.46 7.86 10.99.58.11.79-.26.79-.58 0-.29-.01-1.06-.02-2.08-3.2.7-3.88-1.58-3.88-1.58-.52-1.36-1.28-1.72-1.28-1.72-1.05-.74.08-.73.08-.73 1.16.08 1.77 1.21 1.77 1.21 1.03 1.79 2.71 1.27 3.37.97.1-.76.4-1.27.72-1.56-2.55-.31-5.23-1.33-5.23-5.9 0-1.3.45-2.37 1.19-3.21-.12-.31-.52-1.56.11-3.25 0 0 .97-.32 3.18 1.21.92-.27 1.9-.41 2.88-.41.98 0 1.96.14 2.88.41 2.2-1.53 3.17-1.21 3.17-1.21.64 1.69.24 2.94.12 3.25.74.84 1.19 1.91 1.19 3.21 0 4.58-2.69 5.59-5.25 5.89.41.38.77 1.12.77 2.26 0 1.64-.02 2.96-.02 3.37 0 .32.21.7.8.58 4.56-1.53 7.85-5.86 7.85-10.99C23.5 5.85 18.27.5 12 .5Z" />
      </svg>
    );
  }

  if (type === 'twitter') {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M18.9 2H22l-6.8 7.78L23 22h-6.2l-4.86-6.38L5.4 22H2.2l7.3-8.36L1 2h6.3l4.4 5.73L18.9 2Zm-1.1 18h1.7L6 3.9H4.2l13.6 16.1Z" />
      </svg>
    );
  }

  if (type === 'linkedin') {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.49 1s2.49 1.12 2.49 2.5ZM.3 23.5h4.4V7.9H.3v15.6Zm7.1-15.6h4.2v2.13h.06c.58-1.1 2-2.26 4.13-2.26 4.42 0 5.23 2.91 5.23 6.69v9.04h-4.4v-8.02c0-1.91-.03-4.37-2.66-4.37-2.66 0-3.07 2.08-3.07 4.24v8.15H7.4V7.9Z" />
      </svg>
    );
  }

  return null;
}

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer footer--neural">
      <div className="footer-neural-inner">
        <div className="footer-neural-brand">
          <span className="footer-neural-logo">SubSecAI</span>
          <p className="footer-neural-tagline">
            © {year} SubSecAI. AI-powered exception intelligence for engineering teams.
          </p>
          <div className="footer-social footer-social--inline" aria-label="Social links">
            <a
              href="https://github.com/subsecai"
              target="_blank"
              rel="noreferrer"
              aria-label="GitHub"
            >
              <SocialIcon type="github" />
            </a>
            <a
              href="https://twitter.com/subsecai"
              target="_blank"
              rel="noreferrer"
              aria-label="Twitter"
            >
              <SocialIcon type="twitter" />
            </a>
            <a
              href="https://www.linkedin.com/company/subsecai/"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <SocialIcon type="linkedin" />
            </a>
          </div>
        </div>
        <nav className="footer-neural-nav" aria-label="Footer">
          <Link to="/product">Product</Link>
          <Link to="/docs">Documentation</Link>
          <Link to="/demo">Live demo</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </nav>
      </div>
    </footer>
  );
}
